import { useState } from 'react';
import PropTypes from 'prop-types';
import { hot } from 'react-hot-loader/root';
import { useDispatch, useSelector } from 'react-redux';
import {
  createPerfisFetchAction,
  deletePerfisFetchAction,
  editPerfisFetchAction,
} from '../../../store/fetchActions/perfisActions';
import { MdDelete, MdErrorOutline } from 'react-icons/md';
import * as Styled from '../PerfisUsuarios.styles';
import Table from '../../../components/Table/Table';
import Modal from '../../../components/Modal/Modal';
import { useForm } from 'react-hook-form';
import HybridField from '../../../components/HybridField/HybridField';
import Button from '../../../components/Button/Button';
import Tooltip from '@material-ui/core/Tooltip';
import { theme } from '../../../styles/theme';
import { HiOutlineReceiptTax } from 'react-icons/hi';
import { FaUserCog } from 'react-icons/fa';
import {
  editTaxesFetchAction,
  taxesFetchAction,
} from '../../../store/fetchActions/taxesActions';
import MoneyField from '../../../components/MoneyField/MoneyField';
import {
  ButtonContainer,
  LoadingContainer,
  SmallerModal,
} from '../../GerenciarClientes/styles/GerenciarClientes.styles';
import { CircularProgress } from '@material-ui/core';
import ModalPassword from '../../../components/ModalPassword/ModalPassword';

const {
  mainColor,
  rbmWhite,
  dangerColor,
  warningColor,
  secondaryColor,
  mainColorButtonHover,
  rbmBlack,
} = theme.colors;

function Perfis({ value, index }) {
  const dispatch = useDispatch();
  const [editPerfil, setEditPerfil] = useState({});
  const [modalEditarPerfil, setModalEditarPerfil] = useState(false);
  const [modalCriarPerfil, setModalCriarPerfil] = useState(false);
  const [modalTaxas, setModalTaxas] = useState(false);
  const [modalExcluirPerfil, setModalExcluirPerfil] = useState(false);
  const [dadosExcluirUsuario, setDadosExcluirUsuario] = useState({
    name: '',
    id: '',
  });
  const [modalPasswordEditarPerfil, setModalPasswordEditarPerfil] =
    useState(false);
  const [modalPasswordExcluirPerfil, setModalPasswordExcluirPerfil] =
    useState(false);
  const [modalPasswordEditarTaxas, setModalPasswordEditarTaxas] =
    useState(false);
  const [taxasID, setTaxasID] = useState([]);
  const { cobansData, loadingCobans, errorCobans, errorMessageCobans } =
    useSelector((state) => state.cobans);
  const { taxesData, loadingTaxes } = useSelector((state) => state.taxes);
  const { handleSubmit, control, reset } = useForm({
    defaultValues: editPerfil,
  });

  const {
    handleSubmit: handleCreateProfile,
    control: controlCreateProfile,
    reset: resetCreation,
  } = useForm({});
  const {
    handleSubmit: handleEditTaxes,
    control: controlEditTaxes,
    reset: resetTaxes,
  } = useForm({});

  const fecharModais = () => {
    fecharModalEditarPerfil();
    fecharModalCriarPerfil();
    fecharModalTaxas();
    fecharModalExcluirPerfil();
  };

  const fecharModalExcluirPerfil = () => setModalExcluirPerfil(false);
  const abrirModalExcluirPerfil = () => setModalExcluirPerfil(true);

  const abrirModalEditarPerfil = () => setModalEditarPerfil(true);

  const fecharModalEditarPerfil = () => {
    reset();
    setModalEditarPerfil(false);
  };
  const fecharModalTaxas = () => {
    resetTaxes();
    setModalTaxas(false);
  };

  const abrirModalCriarPerfil = () => setModalCriarPerfil(true);

  const abrirModalPasswordEditarPerfil = () =>
    setModalPasswordEditarPerfil(true);

  const fecharModalPasswordEditarPerfil = () =>
    setModalPasswordEditarPerfil(false);

  const abrirModalPasswordEditarTaxas = () => setModalPasswordEditarTaxas(true);

  const fecharModalPasswordEditarTaxas = () =>
    setModalPasswordEditarTaxas(false);

  const abrirModalPasswordExcluirPerfil = () =>
    setModalPasswordExcluirPerfil(true);

  const fecharModalPasswordExcluirPerfil = () =>
    setModalPasswordExcluirPerfil(false);

  const fecharModalCriarPerfil = () => {
    resetCreation();
    setModalCriarPerfil(false);
  };

  const editTaxes = (id) => {
    dispatch(taxesFetchAction(taxasID));
    setModalTaxas(true);
  };

  const callEditProfileAction = (data) => {
    data.NOME
      ? dispatch(editPerfisFetchAction(data.NOME, editPerfil.id, fecharModais))
      : dispatch(
          editPerfisFetchAction(editPerfil.name, editPerfil.id, fecharModais)
        );
  };

  const callCreateProfileAction = (data) => {
    dispatch(createPerfisFetchAction(data.NOME, fecharModais));
  };

  const callEditTaxesAction = (data) => {
    Object?.keys(data)?.map(function (key, index) {
      if (data[key] !== 0) {
        const removeDigits = data[key].toString().replace('R$\u00a0', '');
        data[key] = removeDigits;
      }
    });
    const edit = {
      ID_COBAN: taxasID,
      TAXAS: data,
    };
    dispatch(editTaxesFetchAction(edit, fecharModais));
  };

  function filterProfile(profile) {
    if (profile.CPFCNPJ === null) {
      return true;
    } else {
      return false;
    }
  }

  const header = [
    {
      id: 'nome',
      name: 'NOME',
      align: 'left',
    },
    {
      id: 'ações',
      name: 'AÇÕES',
      align: 'center',
    },
  ];

  const body =
    cobansData?.length > 0 &&
    cobansData?.filter(filterProfile).map((perfil, index) => {
      return {
        data: [
          { info: perfil.NOME, align: 'left' },
          {
            info: (
              <Styled.Row>
                <Tooltip title="Editar Taxas">
                  <Styled.IconContainer
                    onClick={() => {
                      setTaxasID(perfil.ID);
                      abrirModalPasswordEditarTaxas();
                    }}
                    backgroundColor={'rgba(38, 36, 36, 0.1)'}
                  >
                    <HiOutlineReceiptTax size={25} />
                  </Styled.IconContainer>
                </Tooltip>
                <Tooltip title="Editar Perfil">
                  <Styled.IconContainer
                    onClick={() => {
                      setEditPerfil({ name: perfil.NOME, id: perfil.ID });
                      abrirModalPasswordEditarPerfil();
                    }}
                    backgroundColor={'rgba(38, 36, 36, 0.1)'}
                  >
                    <FaUserCog size={25} />
                  </Styled.IconContainer>
                </Tooltip>

                <Tooltip title="Remover Perfil">
                  <Styled.IconContainer
                    onClick={() => {
                      setDadosExcluirUsuario({
                        name: perfil.NOME,
                        id: perfil.ID,
                      });
                      abrirModalPasswordExcluirPerfil();
                    }}
                    backgroundColor={'rgba(242, 48, 5, 0.1)'}
                    color={'#F23005'}
                  >
                    <MdDelete size={25} />
                  </Styled.IconContainer>
                </Tooltip>
              </Styled.Row>
            ),
          },
        ],
      };
    });

  return (
    <div hidden={value !== index}>
      <Styled.ButtonContainer>
        <Styled.ButtonStatusUsers
          backgroundColor={'#303545'}
          width="12.153vw"
          height="3vw"
          hoverBGColor={'#FF557E'}
          hoverColor={rbmWhite}
          color={rbmWhite}
          onClick={() => abrirModalCriarPerfil()}
        >
          <span className="plus-span">+</span>
          <span>CRIAR PERFIL</span>
        </Styled.ButtonStatusUsers>
      </Styled.ButtonContainer>
      <Modal
        open={modalEditarPerfil}
        close={() => fecharModalEditarPerfil()}
        title="Editar Perfil"
      >
        <form onSubmit={handleSubmit(callEditProfileAction)}>
          <HybridField
            control={control}
            title={'Nome'}
            value={editPerfil.name}
            disabled={false}
            margin={'0 0 2vw  0'}
            width={'29.306vw'}
            name={'NOME'}
          />
          <Button
            backgroundColor={'#303545'}
            width={'29.306vw'}
            height={'3.125vw'}
            margin={'1vw 0'}
            hoverBGColor={mainColor}
            hoverColor={rbmWhite}
            color={rbmWhite}
            type="submit"
          >
            <span>Salvar</span>
          </Button>
        </form>
      </Modal>
      <Modal
        open={modalCriarPerfil}
        close={fecharModalCriarPerfil}
        title="Criar Perfil"
      >
        <form onSubmit={handleCreateProfile(callCreateProfileAction)}>
          <HybridField
            control={controlCreateProfile}
            title={'Nome'}
            value={''}
            disabled={false}
            margin={'0 0 2vw  0'}
            width={'29.306vw'}
            name={'NOME'}
          />
          <Button
            backgroundColor={'#303545'}
            width={'29.306vw'}
            height={'3.125vw'}
            margin={'1vw 0 '}
            hoverBGColor={'#FF557E'}
            hoverColor={rbmWhite}
            color={rbmWhite}
            type="submit"
          >
            <span>CRIAR</span>
          </Button>
        </form>
      </Modal>
      <Modal open={modalTaxas} close={fecharModalTaxas} title="Editar Taxas">
        {loadingTaxes ? (
          <LoadingContainer marginTop={'1vw'}>
            <CircularProgress size={'5vw'} color="inherit" />
          </LoadingContainer>
        ) : (
          <form onSubmit={handleEditTaxes(callEditTaxesAction)}>
            {taxesData?.map((tax) => {
              return (
                <MoneyField
                  key={tax.ID_TIPO_TAXA}
                  control={controlEditTaxes}
                  title={tax.DESCRICAO}
                  value={tax.VALOR}
                  disabled={false}
                  width={'29.306vw'}
                  margin={'0 0 2vw  0'}
                  name={tax.ID_TIPO_TAXA}
                  valueType={tax.ID_TIPO_VALOR}
                />
              );
            })}
            <Button
              backgroundColor={secondaryColor}
              width={'29.306vw'}
              height={'3.125vw'}
              margin={'1vw 0'}
              hoverBGColor={mainColor}
              hoverColor={rbmBlack}
              color={rbmWhite}
              type="submit"
            >
              <span>EDITAR</span>
            </Button>
          </form>
        )}
      </Modal>
      {loadingCobans ? (
        <LoadingContainer>
          <CircularProgress size={'5vw'} color="inherit" />
        </LoadingContainer>
      ) : (
        <Table
          loading={loadingCobans}
          error={errorCobans}
          errorMessage={errorMessageCobans}
          header={header}
          body={body}
        />
      )}

      <ModalPassword
        openModal={modalPasswordExcluirPerfil}
        closeModal={fecharModalPasswordExcluirPerfil}
        nextFunction={abrirModalExcluirPerfil}
      />
      <ModalPassword
        openModal={modalPasswordEditarPerfil}
        closeModal={fecharModalPasswordEditarPerfil}
        nextFunction={abrirModalEditarPerfil}
      />
      <ModalPassword
        openModal={modalPasswordEditarTaxas}
        closeModal={fecharModalPasswordEditarTaxas}
        nextFunction={editTaxes}
      />
      <Modal open={modalExcluirPerfil} close={fecharModalExcluirPerfil}>
        <SmallerModal>
          <MdErrorOutline color={warningColor} size={'6.944vw'} />
          <h3>Excluir Perfil</h3>
          <h5>Tem certeza que deseja excluir o perfil?</h5>
          <ButtonContainer>
            <Button
              backgroundColor={mainColor}
              width={'13.792vw'}
              height={'3.125vw'}
              hoverBGColor={mainColorButtonHover}
              hoverColor={rbmWhite}
              color={secondaryColor}
              onClick={() => {
                fecharModalExcluirPerfil();
              }}
            >
              <span>Voltar</span>
            </Button>
            <Button
              backgroundColor={mainColor}
              width={'13.792vw'}
              height={'3.125vw'}
              hoverBGColor={dangerColor}
              hoverColor={rbmWhite}
              color={rbmWhite}
              roleName="button-confirmar-negar"
              onClick={() =>
                dispatch(
                  deletePerfisFetchAction(
                    dadosExcluirUsuario.name,
                    dadosExcluirUsuario.id,
                    fecharModais
                  )
                )
              }
            >
              <span>Remover</span>
            </Button>
          </ButtonContainer>
        </SmallerModal>
      </Modal>
    </div>
  );
}
export default hot(Perfis);

Perfis.propTypes = {
  index: PropTypes.any.isRequired,
  value: PropTypes.any.isRequired,
};
